import React from "react";

export default function SubtitleText(props) {
  return <h2 className="sp-block sp-h2">{props.text}</h2>;
}
